import { render, staticRenderFns } from "./CreateProduct.vue?vue&type=template&id=59a17adc&scoped=true&"
import script from "./CreateProduct.vue?vue&type=script&lang=js&"
export * from "./CreateProduct.vue?vue&type=script&lang=js&"
import style0 from "./CreateProduct.vue?vue&type=style&index=0&id=59a17adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a17adc",
  null
  
)

export default component.exports